import React from 'react'
import Banner from '../../assets/images/banners/webps/404notfound.webp'
import TopBar from '../../components/general/topbar/TopBar'

export default function NotFound() {

    document.title = "Página no encontrada"

    const style = {
      width: "100vw",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyItems: "center",
      fontSize: "35px",
      fontFamily: 'sans-serif',
      textAlign: "center",
      display: "flex"
    }

    const style2 = {
      width : "none",
      minHeight: "100%",
      position: "absolute",
      top: "0",
      left: "0"
    }

  return (
    <div className='NotFound' style={style}>
        <TopBar />
        Error 404: La pagina a la que esta tratando de acceder no existe
        <img src={Banner} style={style2} alt='Nicolini Refrigeración'/>
    </div>
  )
}
